import React from 'react'

interface Props {
  label: string
  variant: string
}

const StatusBadge = ({ label, variant }: Props) => (
  <span className={`status-badge status-badge--${variant}`}>{label}</span>
)

export default StatusBadge
